import * as React from 'react';
import { RouteComponentProps, withRouter, Redirect } from 'react-router-dom';

import { Loader } from '../../modules/modules';
import CartService from '../../services/CartService';
import { GetFullVariantsBySkuQuery } from '../../components/Query/Products/FullVariantsBySku';
import { ApolloClientFactory } from '../../domain/apolloClientFactory';
import FlashStore from '../../services/FlashStore';
import CountryService from '../../services/CountryService';
import Cart from '../Cart';

interface IExternalCartSceneProps extends RouteComponentProps<{
  language: string;
  items?: string;
}> {
}

interface IParsedItem {
  sku: string;
  quantity: number;
}

interface IExternalCartSceneState {
  loading: boolean;
  parsed: boolean;
  items: IParsedItem[] | null;
  redirect: boolean;
}

class ExternalCartScene extends React.Component<IExternalCartSceneProps, IExternalCartSceneState> {

  public constructor(props: IExternalCartSceneProps) {
    super(props);

    this.state = {
      loading: true,
      parsed: false,
      items: null,
      redirect: false,
    };
  }

  public componentDidMount() {
    let decodeItems: IParsedItem[] = [];
  
    try {
      const { items } = this.props.match.params;

      if (items) {
        CartService.GetInstance().removeEverything();
      }

      if (items) {
        decodeItems = items.split(',').map((item) => {
          const itemSplit = item.split(':');
          const output: IParsedItem = {
            sku: itemSplit[0] as string,
            quantity: parseInt(itemSplit[1], 10) || 1
          };
          return output;
        });

        const client = ApolloClientFactory.GetClient();

        client.query({
          query: GetFullVariantsBySkuQuery,
          variables: {
            skuIn: decodeItems.map(i => i.sku)
          }

        }).then((response) => {
          return (response.data as any).variants;

        }).then((result) => {
          // zkomponuje pole s variantami
          const resume = [...decodeItems].reduce((acc: any, i: IParsedItem) => {
            // najdu variantu
            const variant = result.find((v: GQL.IProductVariant) => v.sku === i.sku);

            // varianta nalezena
            if (variant) {
              acc.found++;
              // přidám variantu do košíku
              CartService.GetInstance().addToCart(variant, undefined, i.quantity || 1);

            } else {
              acc.unknown++;
            }

            return acc;
          }, { found: 0, unknown: 0 });

          // hláška
          if (resume.unknown > 0) {
            FlashStore.GetInstance().showMessage('Some products have not been added to your cart', 'error');
          } else if (resume.found > 0) {
            FlashStore.GetInstance().showMessage('Products have been added to your cart', 'success');
          }

          this.setState({
            redirect: true,
          });
        });

      } else {
        this.setState({
          redirect: true,
        });
      }
    } catch (error) {
      console.log('parse error', error);
    }
  }

  public render() {
    const { countryCode } = CountryService.GetInstance();

    return (
      <>
        <Loader />

        {this.state.redirect &&
          <Redirect to={`/${countryCode}/cart`} />}

        <Cart
          {...this.props}
        />
      </>
    );
  }
}

export default withRouter(ExternalCartScene);


// WEBPACK FOOTER //
// ./src/pages/ExternalCart/ExternalCart.tsx